<template>
  <div id="monitoring-baseline-form" class="">
    <div class="c-app justify-content-center mt-3">
      <div>
        <div class="mb-4">
          <div class="text-center mb-3">
            <div class=" ">
              <img
                src="@/assets/images/ched-header-logo-cropped.png"
                class="mb-3"
              />
            </div>

            <h4 class=" mb-1">
              CHED CARAGA
            </h4>
            <h3 class="font-weight-bold">
              HEI PROFILE - Tuition and Other School Fees
            </h3>
          </div>
        </div>

                    <!-- Search Reference Number Section -->
                    <div class="row mb-4">
              <div class="col-md-12">
                <div class="card shadow-sm">
                  <div class="card-header">
                    <h6 class="mb-0">Search Existing Profile</h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-8">
                        <div class="form-group">
                          <label for="referenceNumber">Reference Number</label>
                          <input 
                            type="text" 
                            v-model="searchReference" 
                            class="form-control" 
                            id="referenceNumber"
                            placeholder="Enter reference number to search existing profile"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>&nbsp;</label>
                          <button 
                            type="button" 
                            class="btn btn-primary btn-block"
                            @click="searchExistingProfile"
                            :disabled="!searchReference"
                          >
                            <i class="bi bi-search"></i> Search Profile
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-if="searchResult" class="mt-3">
                      <div class="alert alert-info">
                        <h6>Found Profile:</h6>
                        <p class="mb-1"><strong>Reference Number:</strong> {{ searchResult.reference_number || 'N/A' }}</p>
                        <p class="mb-1"><strong>HEI Code:</strong> {{ searchResult.hei_code }}</p>
                        <p class="mb-1"><strong>HEI Name:</strong> {{ searchResult.hei_name }}</p>
                        <p class="mb-1"><strong>Address:</strong> {{ searchResult.hei_address }}</p>
                        <p class="mb-1"><strong>Academic Year:</strong> {{ searchResult.academic_year }}</p>
                        <p class="mb-1"><strong>Status:</strong> 
                          <span class="badge" :class="{
                            'badge-success': searchResult.hei_status === 'Active',
                            'badge-warning': searchResult.hei_status === 'Inactive',
                            'badge-danger': searchResult.hei_status === 'Suspended'
                          }">
                            {{ searchResult.hei_status }}
                          </span>
                        </p>
                        <p class="mb-0" v-if="searchResult.programs_data && searchResult.programs_data.length > 0">
                          <strong>Programs:</strong> {{ searchResult.programs_data.length }} program(s) found
                        </p>
                        <div class="mt-2">
                          <button 
                            type="button" 
                            class="btn btn-sm btn-success"
                            @click="loadExistingProfile"
                          >
                            <i class="bi bi-download"></i> Load Profile Data
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-if="searchError" class="mt-3">
                      <div class="alert alert-warning">
                        <i class="bi bi-exclamation-triangle"></i> {{ searchError }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        
        <div class="card rounded shadow-sm">
          <div class="card-body">
            <!-- HEI Information Section -->
            <div class="row mb-4">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="heiName">HEI Name</label>
                  <select v-model="form.hei_code" class="form-control" id="heiName" required>
                    <option value="" disabled>Select HEI *</option>
                    <option v-for="hei in heis" :value="hei.code" :key="hei.id">
                      {{ hei.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="heiAddress">HEI Address</label>
                  <input 
                    type="text" 
                    v-model="form.hei_address" 
                    class="form-control" 
                    id="heiAddress"
                    placeholder="Enter City/Province"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="heiStatus">HEI Status</label>
                  <select v-model="form.hei_status" class="form-control" id="heiStatus">
                    <option value="" disabled>Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="academicYear">Academic Year</label>
                  <select v-model="form.academic_year" class="form-control" id="academicYear">
                    <option value="" disabled>Select Academic Year</option>
                    <option v-for="ay in academicYears" :value="ay" :key="ay">
                      {{ ay }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Degree Programs and Fees Section -->
            <div class="card shadow-sm mb-4">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Degree Programs and Fees</h5>
                <button type="button" class="btn btn-sm btn-success" @click="addProgram">
                  <i class="bi bi-plus"></i> Add Program
                </button>
              </div>
              <div class="card-body p-0">

                <!-- Tab Headers -->
                <ul class="nav nav-tabs px-3 pt-3" style="flex-wrap: nowrap; overflow-x: auto;">
                  <li class="nav-item" v-for="(program, programIndex) in form.programs" :key="`tab-${programIndex}`" style="white-space: nowrap;">
                    <a
                      class="nav-link"
                      :class="{ active: activeProgramTab === programIndex }"
                      href="#"
                      @click.prevent="activeProgramTab = programIndex"
                    >
                      {{ program.degree_program || `Program ${programIndex + 1}` }}
                    </a>
                  </li>
                </ul>

                <!-- Tab Content -->
                <div class="p-3">
                <div v-for="(program, programIndex) in form.programs" :key="`program-${programIndex}`" v-show="activeProgramTab === programIndex">

                  <div class="d-flex justify-content-end mb-3">
                    <button
                      v-if="form.programs.length > 1"
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      @click="removeProgram(programIndex); activeProgramTab = Math.max(0, programIndex - 1)"
                    >
                      <i class="bi bi-trash"></i> Remove Program
                    </button>
                  </div>

                  <div class="form-group mb-3">
                    <label>Degree Program</label>
                    <Multiselect
                      v-model="program.degree_program"
                      :options="degreePrograms"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      :disabled="degreePrograms.length === 0"
                      :placeholder="degreePrograms.length === 0 ? 'Loading programs...' : 'Search or select program'"
                      @select="onDegreeProgramSelect(programIndex, $event)"
                    />
                  </div>

                  <!-- Fees Table -->
                  <div class="table-responsive">
                    <table class="table table-bordered table-sm">
                      <thead class="thead-light">
                        <tr>
                          <th>YEAR LEVEL</th>
                          <th>SEMESTER</th>
                          <th>TOTAL UNITS PER SEMESTER</th>
                          <th>TUITION FEE PER UNIT (P)</th>
                          <th>TOTAL TUITION FEE (P)</th>
                          <th>OTHER SCHOOL FEES (P)</th>
                          <th>TOTAL FEES (P)</th>
                        </tr>
                      </thead>
                      <tbody v-for="(year, yearIndex) in program.years" :key="`year-${programIndex}-${yearIndex}`">
                        <tr>
                          <td class="align-middle text-center font-weight-bold" rowspan="3">
                            {{ getYearName(yearIndex) }}
                          </td>
                          <td>1st Sem</td>
                          <td>
                            <input 
                              type="number" 
                              v-model.number="year.first_sem.units" 
                              class="form-control form-control-sm"
                              @input="calculateFees(programIndex, yearIndex, 'first_sem')"
                            />
                          </td>
                          <td>
                            <input 
                              type="number" 
                              v-model.number="year.first_sem.tuition_per_unit" 
                              class="form-control form-control-sm"
                              @input="calculateFees(programIndex, yearIndex, 'first_sem')"
                            />
                          </td>
                          <td class="text-right">{{ formatCurrency(year.first_sem.total_tuition) }}</td>
                          <td class="text-right">{{ formatCurrency(year.first_sem.other_fees) }}</td>
                          <td class="text-right font-weight-bold">{{ formatCurrency(year.first_sem.total_fees) }}</td>
                        </tr>
                        <tr>
                          <td>2nd Sem</td>
                          <td>
                            <input 
                              type="number" 
                              v-model.number="year.second_sem.units" 
                              class="form-control form-control-sm"
                              @input="calculateFees(programIndex, yearIndex, 'second_sem')"
                            />
                          </td>
                          <td>
                            <input 
                              type="number" 
                              v-model.number="year.second_sem.tuition_per_unit" 
                              class="form-control form-control-sm"
                              @input="calculateFees(programIndex, yearIndex, 'second_sem')"
                            />
                          </td>
                          <td class="text-right">{{ formatCurrency(year.second_sem.total_tuition) }}</td>
                          <td class="text-right">{{ formatCurrency(year.second_sem.other_fees) }}</td>
                          <td class="text-right font-weight-bold">{{ formatCurrency(year.second_sem.total_fees) }}</td>
                        </tr>
                        <tr>
                          <td>3rd Sem / Summer</td>
                          <td>
                            <input 
                              type="number" 
                              v-model.number="year.third_sem.units" 
                              class="form-control form-control-sm"
                              @input="calculateFees(programIndex, yearIndex, 'third_sem')"
                            />
                          </td>
                          <td>
                            <input 
                              type="number" 
                              v-model.number="year.third_sem.tuition_per_unit" 
                              class="form-control form-control-sm"
                              @input="calculateFees(programIndex, yearIndex, 'third_sem')"
                            />
                          </td>
                          <td class="text-right">{{ formatCurrency(year.third_sem.total_tuition) }}</td>
                          <td class="text-right">{{ formatCurrency(year.third_sem.other_fees) }}</td>
                          <td class="text-right font-weight-bold">{{ formatCurrency(year.third_sem.total_fees) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- OSF Management Section -->
                  <div class="mt-4">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h6 class="mb-0">Other School Fees (OSF) Management</h6>
                      <button 
                        type="button" 
                        class="btn btn-sm btn-primary"
                        @click="addOsfItemToProgram(programIndex)"
                      >
                        <i class="bi bi-plus"></i> Add OSF Item
                      </button>
                    </div>
                    
                    <!-- OSF Items List -->
                    <div class="card mb-3">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <h6 class="mb-3">Current OSF Items <small class="text-danger">(You may add or edit OSF items here according to your approved TOSF schedule)</small></h6>
                            <div class="table-responsive">
                              <table class="table table-sm table-bordered">
                                <thead class="thead-light">
                                  <tr>
                                    <th>OSF Item</th>
                                    <th>Default Amount</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                        <tbody>
                          <tr v-for="(item, itemIndex) in program.osf_items" :key="item.id">
                            <td class="font-weight-bold">{{ item.name }}</td>
                            <td class="text-right">{{ formatCurrency(item.amount) }}</td>
                            <td>
                              <span class="badge" :class="item.enabled ? 'badge-success' : 'badge-secondary'">
                                {{ item.enabled ? 'Enabled' : 'Disabled' }}
                              </span>
                            </td>
                            <td>
                              <button 
                                type="button" 
                                class="btn btn-sm btn-outline-primary mr-1"
                                @click="editOsfItem(item, itemIndex, programIndex)"
                                title="Edit OSF Item"
                              >
                                <i class="bi bi-pencil"></i>
                              </button>
                              <button 
                                type="button" 
                                class="btn btn-sm btn-outline-danger"
                                @click="removeOsfItem(itemIndex, programIndex)"
                                title="Remove OSF Item"
                              >
                                <i class="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- OSF Breakdown Table -->
                  <div class="mt-4">
                    <h6 class="mb-3">Other School Fees (OSF) Breakdown</h6>
                    <div class="table-responsive">
                      <table class="table table-bordered table-sm osf-breakdown-table">
                        <thead class="thead-light">
                          <tr>
                            <th>OSF Items</th>
                            <th v-for="(year, yearIndex) in program.years" :key="yearIndex" colspan="3">
                              {{ getYearName(yearIndex) }}
                            </th>
                          </tr>
                          <tr>
                            <th></th>
                            <th v-for="(year, yearIndex) in program.years" :key="yearIndex" colspan="3">
                              <div class="d-flex">
                                <div class="flex-fill text-center">1st Sem</div>
                                <div class="flex-fill text-center">2nd Sem</div>
                                <div class="flex-fill text-center">3rd Sem / Summer</div>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(osfItem, itemIndex) in program.osf_items" :key="osfItem.id">
                            <td class="font-weight-bold">{{ osfItem.name }}</td>
                            <td v-for="cell in getOsfBreakdownCells(programIndex, itemIndex)" :key="cell.key">
                              <div class="d-flex align-items-center" v-if="cell.year[cell.semester] && cell.year[cell.semester].osf_items && cell.year[cell.semester].osf_items[itemIndex]">
                                <input 
                                  type="checkbox" 
                                  :checked="cell.year[cell.semester].osf_items[itemIndex].enabled"
                                  @change="updateOSFItem(programIndex, cell.yearIndex, cell.semester, itemIndex, 'enabled', $event.target.checked)"
                                  class="mr-2"
                                />
                                <input 
                                  type="number" 
                                  :value="cell.year[cell.semester].osf_items[itemIndex].amount"
                                  @input="updateOSFItem(programIndex, cell.yearIndex, cell.semester, itemIndex, 'amount', $event.target.value)"
                                  class="form-control form-control-sm"
                                  :disabled="!cell.year[cell.semester].osf_items[itemIndex].enabled"
                                />
                              </div>
                              <div v-else class="d-flex align-items-center">
                                <input type="checkbox" class="mr-2" disabled />
                                <input type="number" class="form-control form-control-sm" disabled value="0" />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Total per Program -->
                  <div class="text-right mt-3">
                    <h6>TOTAL/AVERAGE PER PROGRAM: {{ formatCurrency(calculateProgramTotal(programIndex)) }}</h6>
                  </div>
                </div>
                </div><!-- end tab content -->

              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-end">
              <button 
                type="button" 
                class="btn btn-secondary mr-2"
                @click="resetForm"
              >
                Reset
              </button>
              <button 
                type="button" 
                class="btn btn-primary"
                @click="submitForm"
                :disabled="!isFormValid || isSubmitting"
              >
                <span v-if="isSubmitting">
                  <i class="bi bi-hourglass-split"></i> {{ isEditMode ? 'Updating...' : 'Submitting...' }}
                </span>
                <span v-else>
                  {{ isEditMode ? 'Update HEI Profile' : 'Submit HEI Profile' }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <div v-if="showSuccessModal" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-success text-white">
            <h5 class="modal-title">
              <i class="bi bi-check-circle-fill"></i> Success!
            </h5>
            <button type="button" class="close text-white" @click="closeSuccessModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div class="mb-4">
              <i class="bi bi-check-circle text-success" style="font-size: 3rem;"></i>
            </div>
            <h4 class="text-success mb-3">{{ isEditMode ? 'HEI Profile Updated Successfully!' : 'HEI Profile Submitted Successfully!' }}</h4>
            <p class="mb-3">{{ isEditMode ? 'Your HEI Profile has been updated and processed.' : 'Your HEI Profile has been submitted and processed.' }}</p>
            <div class="alert alert-info">
              <h6 class="mb-2"><strong>Reference Number:</strong></h6>
              <h4 class="text-primary font-weight-bold">{{ referenceNumber }}</h4>
              <small class="text-muted">Please save this reference number for future reference.</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" @click="closeSuccessModal">
              <i class="bi bi-check"></i> OK
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showSuccessModal" class="modal-backdrop fade show"></div>

    <!-- Add/Edit OSF Item Modal -->
    <div v-if="showAddOsfModal" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <i class="bi bi-plus-circle-fill"></i> {{ editingOsfItem ? 'Edit OSF Item' : 'Add New OSF Item' }}
            </h5>
            <button type="button" class="close text-white" @click="cancelOsfEdit">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="editingOsfItem ? updateOsfItem() : addOsfItem()">
              <div class="form-group">
                <label for="osfItemName">OSF Item Name *</label>
                <input 
                  type="text" 
                  :value="editingOsfItem ? editingOsfItem.name : newOsfItem.name"
                  @input="editingOsfItem ? editingOsfItem.name = $event.target.value : newOsfItem.name = $event.target.value"
                  class="form-control" 
                  id="osfItemName"
                  placeholder="Enter OSF item name"
                  required
                />
              </div>
              
              <div class="form-group">
                <label for="osfItemAmount">Default Amount (₱)</label>
                <input 
                  type="number" 
                  step="0.01"
                  :value="editingOsfItem ? editingOsfItem.amount : newOsfItem.amount"
                  @input="editingOsfItem ? editingOsfItem.amount = parseFloat($event.target.value) || 0 : newOsfItem.amount = parseFloat($event.target.value) || 0"
                  class="form-control" 
                  id="osfItemAmount"
                  placeholder="0.00"
                  min="0"
                />
              </div>
              
              <div class="form-group">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    :checked="editingOsfItem ? editingOsfItem.enabled : newOsfItem.enabled"
                    @change="editingOsfItem ? editingOsfItem.enabled = $event.target.checked : newOsfItem.enabled = $event.target.checked"
                    class="form-check-input" 
                    id="osfItemEnabled"
                  />
                  <label class="form-check-label" for="osfItemEnabled">
                    Enable this OSF item by default
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancelOsfEdit">
              <i class="bi bi-x"></i> Cancel
            </button>
            <button 
              type="button" 
              class="btn btn-primary" 
              @click="editingOsfItem ? updateOsfItem() : addOsfItem()"
            >
              <i class="bi bi-check"></i> {{ editingOsfItem ? 'Update OSF Item' : 'Add OSF Item' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAddOsfModal" class="modal-backdrop fade show"></div>

    <!-- Loading Overlay -->
    <div v-if="isSubmitting" class="loading-overlay">
      <div class="loading-content">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <h5 class="text-primary mb-2">
          {{ isEditMode ? 'Updating HEI Profile...' : 'Submitting HEI Profile...' }}
        </h5>
        <p class="text-muted">Please wait while we process your request</p>
      </div>
    </div>

    <!-- Confirmation Modal -->
    <div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog" aria-labelledby="confirmationModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-warning text-dark">
            <h5 class="modal-title" id="confirmationModalLabel">
              <i class="bi bi-exclamation-triangle-fill mr-2"></i>Confirm Action
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <i class="bi bi-question-circle display-4 text-warning mb-3"></i>
              <p class="mb-0">{{ confirmationMessage }}</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="bi bi-x-circle mr-1"></i>Cancel
            </button>
            <button 
              type="button" 
              class="btn btn-danger" 
              @click="confirmAction"
            >
              <i class="bi bi-check-circle mr-1"></i>Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { awardYears } from '../../js/award-years';
import Multiselect from 'vue-multiselect';

export default {
  name: 'MonitoringBaselineForm',
  components: { Multiselect },
  data() {
    return {
      academicYears: awardYears,
      heis: [],
      degreePrograms: [], // Will be populated dynamically from API
      activeProgramTab: 0,
      showAddOsfModal: false,
      editingOsfItem: null,
      editingOsfItemIndex: null,
      editingProgramIndex: null,
      newOsfItem: {
        name: '',
        amount: 0.00,
        enabled: true
      },
      form: {
        hei_code: '',
        hei_address: '',
        hei_status: '',
        academic_year: '',
        programs: []
      },
      searchReference: '',
      searchResult: null,
      searchError: null,
      showSuccessModal: false,
      referenceNumber: '',
      isEditMode: false,
      existingProfileId: null,
      isSubmitting: false,
      // Confirmation Modal
      confirmationMessage: '',
      confirmationAction: null,
      confirmationData: null
    };
  },

  computed: {
    isFormValid() {
      console.log('Form validation check:', {
        hei_code: this.form.hei_code,
        academic_year: this.form.academic_year,
        programs_length: this.form.programs.length,
        heis_available: this.heis.length,
        programs: this.form.programs
      });
      
      // Check if basic form fields are filled
      if (!this.form.hei_code || !this.form.academic_year) {
        console.log('Basic fields missing - hei_code:', this.form.hei_code, 'academic_year:', this.form.academic_year);
        return false;
      }
      
      // Check if at least one program is added
      if (!this.form.programs.length) {
        console.log('No programs added');
        return false;
      }
      
      // For now, let's make it simpler - just check if HEI and academic year are filled
      // and at least one program exists with a degree program selected
      const hasValidProgram = this.form.programs.some(program => program.degree_program);
      console.log('Has valid program:', hasValidProgram);
      
      return hasValidProgram;
    },
    
    // Helper method to get OSF breakdown rows (used in template)
    getOsfBreakdownCells() {
      return (programIndex, itemIndex) => {
        const program = this.form.programs[programIndex];
        if (!program || !program.years) return [];
        
        const cells = [];
        program.years.forEach((year, yearIndex) => {
          // Ensure all semesters exist
          if (!year.first_sem) year.first_sem = { units: 0, tuition_per_unit: 0, total_tuition: 0, other_fees: 0, total_fees: 0, osf_items: [] };
          if (!year.second_sem) year.second_sem = { units: 0, tuition_per_unit: 0, total_tuition: 0, other_fees: 0, total_fees: 0, osf_items: [] };
          if (!year.third_sem) year.third_sem = { units: 0, tuition_per_unit: 0, total_tuition: 0, other_fees: 0, total_fees: 0, osf_items: [] };
          
          // Ensure osf_items arrays exist and have enough items
          const maxOsfItems = Math.max(
            year.first_sem.osf_items?.length || 0,
            year.second_sem.osf_items?.length || 0,
            year.third_sem.osf_items?.length || 0,
            program.osf_items?.length || 0
          );
          
          // Initialize osf_items arrays if needed
          if (!year.first_sem.osf_items) year.first_sem.osf_items = [];
          if (!year.second_sem.osf_items) year.second_sem.osf_items = [];
          if (!year.third_sem.osf_items) year.third_sem.osf_items = [];
          
          // Ensure each semester has enough OSF items
          while (year.first_sem.osf_items.length < maxOsfItems) {
            const programOsfItem = program.osf_items?.[year.first_sem.osf_items.length];
            year.first_sem.osf_items.push({
              id: programOsfItem?.id || Date.now() + year.first_sem.osf_items.length,
              name: programOsfItem?.name || '',
              amount: programOsfItem?.amount || 0,
              enabled: programOsfItem?.enabled || false
            });
          }
          while (year.second_sem.osf_items.length < maxOsfItems) {
            const programOsfItem = program.osf_items?.[year.second_sem.osf_items.length];
            year.second_sem.osf_items.push({
              id: programOsfItem?.id || Date.now() + year.second_sem.osf_items.length,
              name: programOsfItem?.name || '',
              amount: programOsfItem?.amount || 0,
              enabled: programOsfItem?.enabled || false
            });
          }
          while (year.third_sem.osf_items.length < maxOsfItems) {
            const programOsfItem = program.osf_items?.[year.third_sem.osf_items.length];
            year.third_sem.osf_items.push({
              id: programOsfItem?.id || Date.now() + year.third_sem.osf_items.length,
              name: programOsfItem?.name || '',
              amount: programOsfItem?.amount || 0,
              enabled: programOsfItem?.enabled || false
            });
          }
          
          cells.push({
            yearIndex,
            semester: 'first_sem',
            year,
            key: `osf-first-${programIndex}-${yearIndex}-${itemIndex}`
          });
          cells.push({
            yearIndex,
            semester: 'second_sem',
            year,
            key: `osf-second-${programIndex}-${yearIndex}-${itemIndex}`
          });
          cells.push({
            yearIndex,
            semester: 'third_sem',
            year,
            key: `osf-third-${programIndex}-${yearIndex}-${itemIndex}`
          });
        });
        return cells;
      };
    }
  },

  methods: {
    initializeYears(count = 4) {
      const years = [];
      for (let i = 0; i < count; i++) {
        years.push({
          first_sem: {
            units: 0,
            tuition_per_unit: 0,
            total_tuition: 0,
            other_fees: 0,
            total_fees: 0,
            osf_items: []
          },
          second_sem: {
            units: 0,
            tuition_per_unit: 0,
            total_tuition: 0,
            other_fees: 0,
            total_fees: 0,
            osf_items: []
          },
          third_sem: {
            units: 0,
            tuition_per_unit: 0,
            total_tuition: 0,
            other_fees: 0,
            total_fees: 0,
            osf_items: []
          }
        });
      }
      return years;
    },

    calculateOSFTotal(osfItems) {
      return osfItems.reduce((total, item) => {
        return total + (item.enabled ? parseFloat(item.amount) || 0 : 0);
      }, 0);
    },

    addProgram() {
      this.form.programs.push({
        degree_program: '',
        osf_items: [],
        years: this.initializeYears()
      });
      this.$nextTick(() => {
        this.activeProgramTab = this.form.programs.length - 1;
      });
    },

    removeProgram(index) {
      if (this.form.programs.length > 1) {
        this.form.programs.splice(index, 1);
      }
    },

    onDegreeProgramSelect(programIndex, newValue) {
      this.onDegreeProgramChange(programIndex, { target: { value: newValue } });
    },

    onDegreeProgramChange(programIndex, event) {
      const newValue = event.target.value;
      console.log(`Degree program changed for program ${programIndex + 1}:`, newValue);

      // Use Vue.set to ensure reactivity
      this.$set(this.form.programs[programIndex], 'degree_program', newValue);

      // Set year count based on program (Architecture is a 5-year program)
      const is5Year = newValue && newValue.toLowerCase().includes('architecture');
      const yearCount = is5Year ? 5 : 4;
      this.$set(this.form.programs[programIndex], 'years', this.initializeYears(yearCount));

      // Log the change
      console.log(`Program ${programIndex + 1} degree_program updated to:`, this.form.programs[programIndex].degree_program);

      // Force update to ensure UI reflects the change
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    calculateOsfTotal(osfItems) {
      return osfItems.reduce((total, item) => {
        return total + (item.enabled ? parseFloat(item.amount) || 0 : 0);
      }, 0);
    },

    calculateFees(programIndex, yearIndex, semester) {
      const year = this.form.programs[programIndex].years[yearIndex];
      const sem = year[semester];
      
      // Ensure values are numbers, not strings
      const units = parseFloat(sem.units) || 0;
      const tuitionPerUnit = parseFloat(sem.tuition_per_unit) || 0;
      
      // Calculate total tuition
      sem.total_tuition = units * tuitionPerUnit;
      
      // Calculate total OSF from individual items
      sem.other_fees = this.calculateOSFTotal(sem.osf_items);
      
      // Calculate total fees
      sem.total_fees = sem.total_tuition + sem.other_fees;
      
      // Force reactivity update
      this.$forceUpdate();
    },

    updateOSFItem(programIndex, yearIndex, semester, osfItemIndex, field, value) {
      const year = this.form.programs[programIndex].years[yearIndex];
      const sem = year[semester];
      
      if (sem.osf_items && sem.osf_items[osfItemIndex]) {
        if (field === 'enabled') {
          sem.osf_items[osfItemIndex].enabled = value;
        } else if (field === 'amount') {
          sem.osf_items[osfItemIndex].amount = parseFloat(value) || 0;
        }
        
        // Recalculate fees after OSF update
        this.calculateFees(programIndex, yearIndex, semester);
      }
    },

    addOsfItemToProgram(programIndex) {
      this.editingProgramIndex = programIndex;
      this.showAddOsfModal = true;
    },

    // OSF Item Management Methods
    addOsfItem() {
      if (!this.newOsfItem.name.trim()) {
        toastr.warning('Please enter OSF item name');
        return;
      }
      
      if (this.editingProgramIndex === null) {
        toastr.error('No program selected for adding OSF item');
        return;
      }
      
      const newItem = {
        id: Date.now(), // Use timestamp as unique ID
        name: this.newOsfItem.name.trim(),
        amount: parseFloat(this.newOsfItem.amount) || 0,
        enabled: this.newOsfItem.enabled
      };
      
      const program = this.form.programs[this.editingProgramIndex];
      
      // Initialize osf_items array if it doesn't exist
      if (!program.osf_items) {
        program.osf_items = [];
      }
      
      // Add to program's OSF items
      program.osf_items.push(newItem);
      
      // Add to all years and semesters in this program
      if (program.years) {
        program.years.forEach((year, yearIndex) => {
          // Initialize osf_items if they don't exist
          if (!year.first_sem.osf_items) {
            year.first_sem.osf_items = [];
          }
          if (!year.second_sem.osf_items) {
            year.second_sem.osf_items = [];
          }
          if (!year.third_sem.osf_items) {
            year.third_sem.osf_items = [];
          }
          
          year.first_sem.osf_items.push({
            id: newItem.id,
            name: newItem.name,
            amount: newItem.amount,
            enabled: newItem.enabled
          });
          year.second_sem.osf_items.push({
            id: newItem.id,
            name: newItem.name,
            amount: newItem.amount,
            enabled: newItem.enabled
          });
          year.third_sem.osf_items.push({
            id: newItem.id,
            name: newItem.name,
            amount: newItem.amount,
            enabled: newItem.enabled
          });
          
          // Recalculate fees
          this.calculateFees(this.editingProgramIndex, yearIndex, 'first_sem');
          this.calculateFees(this.editingProgramIndex, yearIndex, 'second_sem');
          this.calculateFees(this.editingProgramIndex, yearIndex, 'third_sem');
        });
      }
      
      // Reset form
      this.newOsfItem = {
        name: '',
        amount: 0.00,
        enabled: true
      };
      this.editingProgramIndex = null;
      
      this.showAddOsfModal = false;
      toastr.success('OSF item added successfully');
    },

    editOsfItem(item, itemIndex, programIndex) {
      this.editingOsfItem = { ...item };
      this.editingOsfItemIndex = itemIndex;
      this.editingProgramIndex = programIndex;
      this.showAddOsfModal = true;
    },

    updateOsfItem() {
      if (!this.editingOsfItem.name.trim()) {
        toastr.warning('Please enter OSF item name');
        return;
      }
      
      if (this.editingProgramIndex === null || this.editingOsfItemIndex === null) {
        toastr.error('No program or item selected for editing');
        return;
      }
      
      const program = this.form.programs[this.editingProgramIndex];
      
      // Update the program's OSF items
      if (program.osf_items && program.osf_items[this.editingOsfItemIndex]) {
        program.osf_items[this.editingOsfItemIndex] = { ...this.editingOsfItem };
        
        // Update all years and semesters in this program
        if (program.years) {
          program.years.forEach((year, yearIndex) => {
            if (year.first_sem.osf_items && year.first_sem.osf_items[this.editingOsfItemIndex]) {
              year.first_sem.osf_items[this.editingOsfItemIndex] = {
                id: this.editingOsfItem.id,
                name: this.editingOsfItem.name,
                amount: this.editingOsfItem.amount,
                enabled: this.editingOsfItem.enabled
              };
              this.calculateFees(this.editingProgramIndex, yearIndex, 'first_sem');
            }
            
            if (year.second_sem.osf_items && year.second_sem.osf_items[this.editingOsfItemIndex]) {
              year.second_sem.osf_items[this.editingOsfItemIndex] = {
                id: this.editingOsfItem.id,
                name: this.editingOsfItem.name,
                amount: this.editingOsfItem.amount,
                enabled: this.editingOsfItem.enabled
              };
              this.calculateFees(this.editingProgramIndex, yearIndex, 'second_sem');
            }
            
            if (year.third_sem.osf_items && year.third_sem.osf_items[this.editingOsfItemIndex]) {
              year.third_sem.osf_items[this.editingOsfItemIndex] = {
                id: this.editingOsfItem.id,
                name: this.editingOsfItem.name,
                amount: this.editingOsfItem.amount,
                enabled: this.editingOsfItem.enabled
              };
              this.calculateFees(this.editingProgramIndex, yearIndex, 'third_sem');
            }
          });
        }
        
        toastr.success('OSF item updated successfully');
      }
      
      this.editingOsfItem = null;
      this.editingOsfItemIndex = null;
      this.editingProgramIndex = null;
      this.showAddOsfModal = false;
    },

    removeOsfItem(itemIndex, programIndex) {
      const program = this.form.programs[programIndex];
      const item = program.osf_items[itemIndex];
      const itemName = item ? item.name : 'this OSF item';
      
      this.confirmationMessage = `Are you sure you want to remove "${itemName}"? This will remove it from this program.`;
      this.confirmationAction = () => this.executeRemoveOsfItem(itemIndex, programIndex);
      this.confirmationData = { itemIndex, itemName, programIndex };
      
      $('#confirmationModal').modal('show');
    },

    executeRemoveOsfItem(itemIndex, programIndex) {
      const program = this.form.programs[programIndex];
      
      if (program.osf_items && program.osf_items[itemIndex]) {
        const removedItem = program.osf_items[itemIndex];
        
        // Remove from program's OSF items
        program.osf_items.splice(itemIndex, 1);
        
        // Remove from all years and semesters in this program
        if (program.years) {
          program.years.forEach((year, yearIndex) => {
            if (year.first_sem.osf_items) {
              year.first_sem.osf_items = year.first_sem.osf_items.filter(osf => osf.id !== removedItem.id);
              this.calculateFees(programIndex, yearIndex, 'first_sem');
            }
            if (year.second_sem.osf_items) {
              year.second_sem.osf_items = year.second_sem.osf_items.filter(osf => osf.id !== removedItem.id);
              this.calculateFees(programIndex, yearIndex, 'second_sem');
            }
            if (year.third_sem.osf_items) {
              year.third_sem.osf_items = year.third_sem.osf_items.filter(osf => osf.id !== removedItem.id);
              this.calculateFees(programIndex, yearIndex, 'third_sem');
            }
          });
        }
        
        toastr.success('OSF item removed successfully');
      }
      
      $('#confirmationModal').modal('hide');
    },

    confirmAction() {
      if (this.confirmationAction) {
        this.confirmationAction();
      }
    },

    cancelOsfEdit() {
      this.editingOsfItem = null;
      this.editingOsfItemIndex = null;
      this.editingProgramIndex = null;
      this.showAddOsfModal = false;
      this.newOsfItem = {
        name: '',
        amount: 0.00,
        enabled: true
      };
    },

    getYearName(yearIndex) {
      const yearNames = ['First Year', 'Second Year', 'Third Year', 'Fourth Year', 'Fifth Year'];
      return yearNames[yearIndex] || `Year ${yearIndex + 1}`;
    },

    calculateProgramTotal(programIndex) {
      const program = this.form.programs[programIndex];
      let total = 0;
      
      program.years.forEach(year => {
        const firstSemTotal = parseFloat(year.first_sem.total_fees) || 0;
        const secondSemTotal = parseFloat(year.second_sem.total_fees) || 0;
        const thirdSemTotal = parseFloat(year.third_sem.total_fees) || 0;
        total += firstSemTotal + secondSemTotal + thirdSemTotal;
      });
      
      return total;
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat('en-PH', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2
      }).format(amount);
    },

    async getHeis() {
      try {
        console.log('Loading HEIs...');
        const response = await axios.get('api/heis');
        console.log('HEI API response:', response.data);
        this.heis = response.data.filter(hei => hei.status === "Active");
        console.log('Filtered active HEIs:', this.heis);
      } catch (error) {
        console.error('Error loading HEIs:', error);
        toastr.error('Failed to load HEIs');
        // Add some dummy data for testing
        this.heis = [
          { id: 1, name: 'Test HEI 1', status: 'Active' },
          { id: 2, name: 'Test HEI 2', status: 'Active' }
        ];
        console.log('Using dummy HEI data:', this.heis);
      }
    },

    async getPrograms() {
      try {
        console.log('Loading programs...');
        const response = await axios.get('api/programs-public');
        console.log('Programs API response:', response.data);
        // Extract program names from the response
        this.degreePrograms = response.data.map(program => program.name || program.program_name);
        console.log('Loaded programs:', this.degreePrograms);
      } catch (error) {
        console.error('Error loading programs:', error);
        toastr.error('Failed to load programs');
        // Keep the static list as fallback
        console.log('Using fallback program list');
      }
    },

    resetForm() {
      this.form = {
        hei_code: '',
        hei_address: '',
        hei_status: '',
        academic_year: '',
        programs: []
      };
      this.searchReference = '';
      this.searchResult = null;
      this.searchError = null;
      this.isEditMode = false;
      this.existingProfileId = null;
      this.isSubmitting = false;
      // Add one program after reset
      this.addProgram();
    },

    async searchExistingProfile() {
      if (!this.searchReference.trim()) {
        toastr.warning('Please enter a reference number');
        return;
      }

      try {
        this.searchError = null;
        this.searchResult = null;
        
        console.log('Searching for reference number:', this.searchReference);
        const response = await axios.post('api/hei-profile/search', {
          reference_number: this.searchReference.trim()
        });
        
        if (response.data && response.data.success) {
          // Handle both single profile and array of profiles
          const profileData = Array.isArray(response.data.data) 
            ? response.data.data[0] 
            : response.data.data;
          
          this.searchResult = profileData;
          toastr.success('Profile found successfully');
        } else {
          this.searchError = 'No profile found with this reference number';
        }
      } catch (error) {
        console.error('Error searching profile:', error);
        this.searchError = 'Failed to search profile. Please try again.';
        toastr.error('Failed to search profile');
      }
    },

    loadExistingProfile() {
      if (!this.searchResult) {
        toastr.error('No profile data to load');
        return;
      }

      try {
        console.log('Loading profile data:', this.searchResult);
        
        // Set edit mode and store the existing profile ID
        this.isEditMode = true;
        this.existingProfileId = this.searchResult.id;
        
        // Load the existing profile data into the form
        this.form.hei_code = this.searchResult.hei_code || '';
        this.form.hei_address = this.searchResult.hei_address || '';
        this.form.hei_status = this.searchResult.hei_status || '';
        this.form.academic_year = this.searchResult.academic_year || '';
        
        // Load programs data if available
        if (this.searchResult.programs_data && this.searchResult.programs_data.length > 0) {
          console.log('Loading programs_data:', this.searchResult.programs_data);
          console.log('Programs count:', this.searchResult.programs_data.length);
          
          // Check for invalid programs but don't filter (to preserve indices)
          this.searchResult.programs_data.forEach((p, idx) => {
            if (!p || typeof p !== 'object') {
              console.warn(`Program at index ${idx} is invalid:`, p);
            }
          });
          
          // Convert programs_data to the expected format
          this.form.programs = this.searchResult.programs_data.map((program, index) => {
            // Skip if program is invalid
            if (!program || typeof program !== 'object') {
              console.warn(`Skipping invalid program at index ${index}`);
              return {
                degree_program: '',
                osf_items: [],
                years: this.initializeYears()
              };
            }
            // Log ALL properties of the program object to see what's actually there
            const allKeys = Object.keys(program);
            console.log(`Program ${index} - ALL PROPERTIES:`, allKeys);
            console.log(`Program ${index} - FULL OBJECT:`, JSON.parse(JSON.stringify(program)));
            
            // Handle different possible property names for degree_program
            // Check all possible variations, including checking for truthy values
            const degreeProgram = (program.degree_program && String(program.degree_program).trim()) || 
                                 (program.degreeProgram && String(program.degreeProgram).trim()) || 
                                 (program.degree && String(program.degree).trim()) || 
                                 (program.program_name && String(program.program_name).trim()) ||
                                 (program.programName && String(program.programName).trim()) ||
                                 (program.name && String(program.name).trim()) ||
                                 (program.program && String(program.program).trim()) ||
                                 (program.title && String(program.title).trim()) ||
                                 '';
            
            console.log(`Program ${index} - EXTRACTED degree_program:`, degreeProgram);
            console.log(`Program ${index} - Raw values:`, {
              'degree_program': program.degree_program,
              'degreeProgram': program.degreeProgram,
              'degree': program.degree,
              'program_name': program.program_name,
              'programName': program.programName,
              'name': program.name,
              'program': program.program,
              'title': program.title
            });
            
            // Special logging for programs 9 and 10 (indices 8 and 9)
            if (index === 8 || index === 9) {
              console.log(`=== PROGRAM ${index + 1} (index ${index}) DETAILED DEBUG ===`);
              console.log('Full program object:', JSON.parse(JSON.stringify(program)));
              console.log('All property names:', Object.keys(program));
              console.log('degree_program value:', program.degree_program);
              console.log('degree_program type:', typeof program.degree_program);
              console.log('degree_program truthy?', !!program.degree_program);
              if (program.degree_program) {
                console.log('degree_program length:', String(program.degree_program).length);
                console.log('degree_program trimmed:', String(program.degree_program).trim());
              }
            }
            
            const newProgram = {
              degree_program: degreeProgram,
              osf_items: program.osf_items || program.osfItems || [], // Load program-level OSF items
              years: this.initializeYears()
            };
            
            // Load existing years data if available
            if (program.years && program.years.length > 0) {
              program.years.forEach((year, yearIndex) => {
                if (newProgram.years[yearIndex]) {
                  // Load basic fee data
                  if (year.first_sem || year.firstSem) {
                    const firstSem = year.first_sem || year.firstSem;
                    newProgram.years[yearIndex].first_sem.units = firstSem.units || 0;
                    newProgram.years[yearIndex].first_sem.tuition_per_unit = firstSem.tuition_per_unit || firstSem.tuitionPerUnit || 0;
                    // Load OSF breakdown if available
                    if (firstSem.osf_items || firstSem.osfItems) {
                      newProgram.years[yearIndex].first_sem.osf_items = firstSem.osf_items || firstSem.osfItems;
                    }
                  }
                  if (year.second_sem || year.secondSem) {
                    const secondSem = year.second_sem || year.secondSem;
                    newProgram.years[yearIndex].second_sem.units = secondSem.units || 0;
                    newProgram.years[yearIndex].second_sem.tuition_per_unit = secondSem.tuition_per_unit || secondSem.tuitionPerUnit || 0;
                    // Load OSF breakdown if available
                    if (secondSem.osf_items || secondSem.osfItems) {
                      newProgram.years[yearIndex].second_sem.osf_items = secondSem.osf_items || secondSem.osfItems;
                    }
                  }
                  // Handle third_sem - initialize if it doesn't exist in old data
                  if (year.third_sem || year.thirdSem || year.summer_sem || year.summerSem) {
                    const thirdSem = year.third_sem || year.thirdSem || year.summer_sem || year.summerSem;
                    newProgram.years[yearIndex].third_sem.units = thirdSem.units || 0;
                    newProgram.years[yearIndex].third_sem.tuition_per_unit = thirdSem.tuition_per_unit || thirdSem.tuitionPerUnit || 0;
                    // Load OSF breakdown if available
                    if (thirdSem.osf_items || thirdSem.osfItems) {
                      newProgram.years[yearIndex].third_sem.osf_items = thirdSem.osf_items || thirdSem.osfItems;
                    }
                  } else {
                    // If third_sem doesn't exist in old data, ensure it's initialized with OSF items
                    // Copy OSF items from first_sem if available, otherwise initialize empty array
                    if (newProgram.years[yearIndex].first_sem.osf_items && newProgram.years[yearIndex].first_sem.osf_items.length > 0) {
                      // Deep copy OSF items from first_sem to third_sem
                      newProgram.years[yearIndex].third_sem.osf_items = newProgram.years[yearIndex].first_sem.osf_items.map(item => ({
                        ...item,
                        enabled: false, // Default to disabled for third sem if not in old data
                        amount: item.amount || 0
                      }));
                    } else if (newProgram.osf_items && newProgram.osf_items.length > 0) {
                      // If no semester-specific OSF items, use program-level OSF items
                      newProgram.years[yearIndex].third_sem.osf_items = newProgram.osf_items.map(item => ({
                        id: item.id,
                        name: item.name,
                        amount: item.amount || 0,
                        enabled: false // Default to disabled for third sem if not in old data
                      }));
                    }
                  }
                }
              });
            }
            
            return newProgram;
          });
          
          console.log('=== FINAL MAPPED PROGRAMS ===');
          console.log('Total programs mapped:', this.form.programs.length);
          
          // Log each program's final state
          this.form.programs.forEach((program, idx) => {
            console.log(`Program ${idx + 1} (index ${idx}) final state:`, {
              degree_program: program.degree_program,
              degree_program_type: typeof program.degree_program,
              degree_program_length: program.degree_program ? program.degree_program.length : 0,
              has_years: !!program.years,
              years_count: program.years ? program.years.length : 0,
              full_program: program
            });
          });
          
          // Specifically check programs 9 and 10 (indices 8 and 9)
          if (this.form.programs[8]) {
            console.log('=== PROGRAM 9 (index 8) DETAILED ===', this.form.programs[8]);
          }
          if (this.form.programs[9]) {
            console.log('=== PROGRAM 10 (index 9) DETAILED ===', this.form.programs[9]);
          }
          
          const programsWithDegree = this.form.programs.filter(p => p.degree_program && p.degree_program.trim() !== '').length;
          console.log('Programs with degree_program:', programsWithDegree, 'out of', this.form.programs.length);
          
          // Warn if some programs don't have degree_program set
          if (programsWithDegree < this.form.programs.length) {
            const missingCount = this.form.programs.length - programsWithDegree;
            const missingIndices = this.form.programs
              .map((p, idx) => ({ idx, hasDegree: p.degree_program && p.degree_program.trim() !== '' }))
              .filter(item => !item.hasDegree)
              .map(item => item.idx + 1);
            console.warn(`${missingCount} program(s) are missing degree_program. Indices:`, missingIndices);
            toastr.warning(`Programs ${missingIndices.join(', ')} are missing degree program. Please select a degree program for each.`, 'Incomplete Data', { timeOut: 7000 });
          }
          
          // Check if degree_program values exist in degreePrograms options and add missing ones
          this.form.programs.forEach((program, idx) => {
            if (program.degree_program && program.degree_program.trim() !== '') {
              const existsInOptions = this.degreePrograms.includes(program.degree_program);
              if (!existsInOptions) {
                console.warn(`Program ${idx + 1} degree_program "${program.degree_program}" not found in degreePrograms options, adding it...`);
                // Add the missing degree_program to the options so it can be displayed
                this.degreePrograms.push(program.degree_program);
                console.log(`Added "${program.degree_program}" to degreePrograms options`);
              } else {
                console.log(`Program ${idx + 1} degree_program "${program.degree_program}" found in options`);
              }
            }
          });
          
          // Ensure Vue reactivity for the entire programs array and each program
          // First, ensure each program has all required properties
          const reactivePrograms = this.form.programs.map((program, idx) => {
            // Ensure years property exists and is properly initialized
            if (!program.years || !Array.isArray(program.years) || program.years.length === 0) {
              console.warn(`Program ${idx + 1} missing years, initializing...`);
              program.years = this.initializeYears();
            }
            // Ensure osf_items exists
            if (!program.osf_items || !Array.isArray(program.osf_items)) {
              program.osf_items = program.osf_items || [];
            }
            // Ensure degree_program exists (keep existing value)
            if (program.degree_program === undefined) {
              program.degree_program = '';
            }
            // Return a new object to ensure reactivity
            return { ...program };
          });
          
          // Replace the entire array using Vue.set to ensure reactivity
          this.$set(this.form, 'programs', reactivePrograms);
          
          // Also ensure each program in the array is reactive
          reactivePrograms.forEach((program, idx) => {
            this.$set(this.form.programs, idx, program);
          });
          
          // Use nextTick to ensure Vue has processed the array change
          this.$nextTick(() => {
            // Verify programs 9 & 10 are set correctly
            if (this.form.programs[8]) {
              console.log('=== PROGRAM 9 VERIFICATION ===');
              console.log('degree_program value:', this.form.programs[8].degree_program);
              console.log('Is in degreePrograms?', this.degreePrograms.includes(this.form.programs[8].degree_program));
              console.log('Full program object:', JSON.parse(JSON.stringify(this.form.programs[8])));
            }
            if (this.form.programs[9]) {
              console.log('=== PROGRAM 10 VERIFICATION ===');
              console.log('degree_program value:', this.form.programs[9].degree_program);
              console.log('Is in degreePrograms?', this.degreePrograms.includes(this.form.programs[9].degree_program));
              console.log('Full program object:', JSON.parse(JSON.stringify(this.form.programs[9])));
            }
            
            // Recalculate fees for all programs
            this.form.programs.forEach((program, programIndex) => {
              if (program.years) {
                program.years.forEach((year, yearIndex) => {
                  this.calculateFees(programIndex, yearIndex, 'first_sem');
                  this.calculateFees(programIndex, yearIndex, 'second_sem');
                  this.calculateFees(programIndex, yearIndex, 'third_sem');
                });
              }
            });
            
            // Force update to ensure UI reflects changes
            this.$forceUpdate();
            
            // Final check for programs 9 & 10
            console.log('=== FINAL CHECK AFTER ALL UPDATES ===');
            console.log('Program 9 (index 8):', this.form.programs[8] ? {
              degree_program: this.form.programs[8].degree_program,
              full_object: this.form.programs[8]
            } : 'NOT FOUND');
            console.log('Program 10 (index 9):', this.form.programs[9] ? {
              degree_program: this.form.programs[9].degree_program,
              full_object: this.form.programs[9]
            } : 'NOT FOUND');
          });
          
          toastr.success(`Loaded ${this.form.programs.length} program(s) from existing profile`);
        } else if (this.searchResult.programs && this.searchResult.programs.length > 0) {
          // Fallback to programs field if programs_data doesn't exist
          console.log('Loading programs (fallback):', this.searchResult.programs);
          this.form.programs = this.searchResult.programs.map((program, index) => {
            // Handle different possible property names for degree_program
            const degreeProgram = program.degree_program || 
                                 program.degreeProgram || 
                                 program.degree || 
                                 program.program_name ||
                                 program.name ||
                                 '';
            
            console.log(`Program ${index} (fallback):`, {
              original: program,
              degree_program: degreeProgram
            });
            
            const newProgram = {
              degree_program: degreeProgram,
              osf_items: program.osf_items || program.osfItems || [],
              years: this.initializeYears()
            };
            
            // Load existing years data if available
            if (program.years && program.years.length > 0) {
              program.years.forEach((year, yearIndex) => {
                if (newProgram.years[yearIndex]) {
                  // Load basic fee data
                  if (year.first_sem || year.firstSem) {
                    const firstSem = year.first_sem || year.firstSem;
                    newProgram.years[yearIndex].first_sem.units = firstSem.units || 0;
                    newProgram.years[yearIndex].first_sem.tuition_per_unit = firstSem.tuition_per_unit || firstSem.tuitionPerUnit || 0;
                    // Load OSF breakdown if available
                    if (firstSem.osf_items || firstSem.osfItems) {
                      newProgram.years[yearIndex].first_sem.osf_items = firstSem.osf_items || firstSem.osfItems;
                    }
                  }
                  if (year.second_sem || year.secondSem) {
                    const secondSem = year.second_sem || year.secondSem;
                    newProgram.years[yearIndex].second_sem.units = secondSem.units || 0;
                    newProgram.years[yearIndex].second_sem.tuition_per_unit = secondSem.tuition_per_unit || secondSem.tuitionPerUnit || 0;
                    // Load OSF breakdown if available
                    if (secondSem.osf_items || secondSem.osfItems) {
                      newProgram.years[yearIndex].second_sem.osf_items = secondSem.osf_items || secondSem.osfItems;
                    }
                  }
                  // Handle third_sem - initialize if it doesn't exist in old data
                  if (year.third_sem || year.thirdSem || year.summer_sem || year.summerSem) {
                    const thirdSem = year.third_sem || year.thirdSem || year.summer_sem || year.summerSem;
                    newProgram.years[yearIndex].third_sem.units = thirdSem.units || 0;
                    newProgram.years[yearIndex].third_sem.tuition_per_unit = thirdSem.tuition_per_unit || thirdSem.tuitionPerUnit || 0;
                    // Load OSF breakdown if available
                    if (thirdSem.osf_items || thirdSem.osfItems) {
                      newProgram.years[yearIndex].third_sem.osf_items = thirdSem.osf_items || thirdSem.osfItems;
                    }
                  } else {
                    // If third_sem doesn't exist in old data, ensure it's initialized with OSF items
                    // Copy OSF items from first_sem if available, otherwise initialize empty array
                    if (newProgram.years[yearIndex].first_sem.osf_items && newProgram.years[yearIndex].first_sem.osf_items.length > 0) {
                      // Deep copy OSF items from first_sem to third_sem
                      newProgram.years[yearIndex].third_sem.osf_items = newProgram.years[yearIndex].first_sem.osf_items.map(item => ({
                        ...item,
                        enabled: false, // Default to disabled for third sem if not in old data
                        amount: item.amount || 0
                      }));
                    } else if (newProgram.osf_items && newProgram.osf_items.length > 0) {
                      // If no semester-specific OSF items, use program-level OSF items
                      newProgram.years[yearIndex].third_sem.osf_items = newProgram.osf_items.map(item => ({
                        id: item.id,
                        name: item.name,
                        amount: item.amount || 0,
                        enabled: false // Default to disabled for third sem if not in old data
                      }));
                    }
                  }
                }
              });
            }
            
            return newProgram;
          });
          
          const programsWithDegree = this.form.programs.filter(p => p.degree_program && p.degree_program.trim() !== '').length;
          console.log('Programs with degree_program (fallback):', programsWithDegree, 'out of', this.form.programs.length);
          
          if (programsWithDegree < this.form.programs.length) {
            const missingCount = this.form.programs.length - programsWithDegree;
            console.warn(`${missingCount} program(s) are missing degree_program (fallback)`);
            toastr.warning(`${missingCount} program(s) are missing degree program. Please select a degree program for each.`, 'Incomplete Data', { timeOut: 5000 });
          }
          
          // Recalculate fees for all programs
          this.form.programs.forEach((program, programIndex) => {
            if (program.years) {
              program.years.forEach((year, yearIndex) => {
                this.calculateFees(programIndex, yearIndex, 'first_sem');
                this.calculateFees(programIndex, yearIndex, 'second_sem');
                this.calculateFees(programIndex, yearIndex, 'third_sem');
              });
            }
          });
          
          toastr.success(`Loaded ${this.form.programs.length} program(s) from existing profile`);
        } else {
          // If no programs data, initialize with one empty program
          this.form.programs = [];
          this.addProgram();
          toastr.info('No programs found in existing profile. Added empty program.');
        }
        
        toastr.success('Profile data loaded successfully - You are now in edit mode');
        console.log('Form after loading:', this.form);
      } catch (error) {
        console.error('Error loading profile:', error);
        toastr.error('Failed to load profile data');
      }
    },

    closeSuccessModal() {
      this.showSuccessModal = false;
      this.referenceNumber = '';
      // Reset form after successful submission
      this.resetForm();
    },

    async submitForm() {
      if (!this.isFormValid) {
        toastr.error('Please fill in all required fields');
        return;
      }

      this.isSubmitting = true;

      try {
        // Prepare the data to send - ensure programs_data is included
        const submitData = {
          ...this.form,
          programs_data: this.form.programs || [], // Send as programs_data for API compatibility
          programs: this.form.programs || [] // Also include programs for backward compatibility
        };
        
        // Log the data being sent, especially programs 9 & 10
        console.log('=== SUBMITTING FORM DATA ===');
        console.log('Total programs:', submitData.programs_data.length);
        console.log('Program 9 (index 8):', submitData.programs_data[8] ? {
          degree_program: submitData.programs_data[8].degree_program,
          full: submitData.programs_data[8]
        } : 'NOT FOUND');
        console.log('Program 10 (index 9):', submitData.programs_data[9] ? {
          degree_program: submitData.programs_data[9].degree_program,
          full: submitData.programs_data[9]
        } : 'NOT FOUND');
        console.log('Full submit data:', JSON.parse(JSON.stringify(submitData)));
        
        let response;
        
        if (this.isEditMode && this.existingProfileId) {
          // Update existing profile
          console.log('Updating existing profile with ID:', this.existingProfileId);
          response = await axios.put(`api/hei-profile-update/${this.existingProfileId}`, submitData);
          toastr.success('HEI Profile updated successfully');
        } else {
          // Create new profile
          console.log('Creating new profile');
          response = await axios.post('api/hei-profile/submit', submitData);
          toastr.success('HEI Profile created successfully');
        }
        
        console.log('Response:', response.data);
        
        // Extract reference number from response
        const refNumber = response.data?.reference_number || 
                         response.data?.data?.reference_number || 
                         response.data?.id || 
                         this.searchResult?.reference_number ||
                         'N/A';
        
        // Show success modal with reference number
        this.referenceNumber = refNumber;
        this.showSuccessModal = true;
        
      } catch (error) {
        console.error('Error submitting form:', error);
        const action = this.isEditMode ? 'update' : 'create';
        toastr.error(`Failed to ${action} HEI Profile`);
      } finally {
        this.isSubmitting = false;
      }
    }
  },

  mounted() {
    this.getHeis();
    this.getPrograms();
    // Initialize with one program
    this.addProgram();
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
  font-size: 0.875rem;
}

.table td {
  font-size: 0.875rem;
}

.form-control-sm {
  font-size: 0.875rem;
}

.btn-success {
  background-color: #28a745;
  border-color: #28a745;
}

.btn-success:hover {
  background-color: #218838;
  border-color: #1e7e34;
}

.align-middle {
  vertical-align: middle;
}

.font-weight-bold {
  font-weight: 600;
}

.text-right {
  text-align: right;
}

.table-responsive {
  border-radius: 0.375rem;
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.card-header h5 {
  color: #495057;
  font-weight: 600;
}

/* Modal Styles */
.modal.show {
  display: block !important;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header.bg-success {
  background-color: #28a745 !important;
}

.modal-title i {
  margin-right: 0.5rem;
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

/* OSF Breakdown Table Styles */
.osf-breakdown-table th {
  background-color: #e9ecef;
  font-weight: 600;
  font-size: 0.8rem;
  text-align: center;
}

.osf-breakdown-table td {
  font-size: 0.8rem;
  padding: 0.25rem;
}

.osf-breakdown-table input[type="checkbox"] {
  margin-right: 0.25rem;
}

.osf-breakdown-table input[type="number"] {
  width: 80px;
  font-size: 0.75rem;
}

.osf-breakdown-table .form-control-sm {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.flex-fill {
  flex: 1 1 auto;
}

/* OSF Management Styles */
.osf-management-card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

.osf-items-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  font-size: 0.875rem;
}

.osf-items-table td {
  font-size: 0.875rem;
  vertical-align: middle;
}

.badge-success {
  background-color: #28a745;
}

.badge-secondary {
  background-color: #6c757d;
}

.modal-header.bg-primary {
  background-color: #007bff !important;
}

/* Loading Overlay Styles */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  background-color: white;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  text-align: center;
  min-width: 300px;
}

.loading-content .spinner-border {
  width: 3rem;
  height: 3rem;
}

.loading-content h5 {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.loading-content p {
  margin-bottom: 0;
  font-size: 0.9rem;
}
</style>
